import { FormControl as BUFormControl, StyledCaption, StyledControlContainer, StyledLabel } from 'baseui/form-control'
import React, { ComponentProps } from 'react'
import { withStyle } from '../../theme'

export type FormControlProps = ComponentProps<typeof BUFormControl>

const BaseFormControlLabel = withStyle(StyledLabel, ({ $theme, $error }) => ({
    ...$theme.typography.ParagraphXSmall,
    color: $error ? $theme.colors.negative700 : $theme.colors.mono400
}))

const BaseFormControlCaption = withStyle(StyledCaption, ({ $theme, $error }) => ({
    ...$theme.typography.ParagraphXSmall,
    color: $error ? $theme.colors.negative700 : $theme.colors.mono400
}))

const FormControl = ({ ...props }: FormControlProps) => {
    return <BUFormControl overrides={{ Label: BaseFormControlLabel, Caption: BaseFormControlCaption }} {...props} />
}

export { BaseFormControlCaption, BaseFormControlLabel, StyledCaption, StyledControlContainer, StyledLabel, FormControl }
